import {
    allFetch
} from "../Domain";
/**
 * @description 維修清單匯出 Excel
 */
const RepairListDetailReport = async function (obj = {
    wom_code: '',
    status: new Array(),
    position_id: '',
    customer_id: '',
    car_id: '',
    license_plate: '',
    time_enter_start: '',
    time_enter_end: '',
    time_leave_start: '',
    time_leave_end: '',
    insurance_company_id: '',
    is_complete: '',
    complete_time_start: '',
    complete_time_end: '',
    is_caseclose: '',
    caseclose_time_start: '',
    caseclose_time_end: '',
    is_invalid: '',
    invalid_time_start: '',
    invalid_time_end: '',
    page: 0,
    num_per_page: 10
}) {
    return await allFetch('Report/RepairListDetailReport', obj);
}

/**
 * @description 維修清單匯出 Excel
 */
const WorkOrderPayLogReport = async function (obj = {
    wom_code: '',
    status: new Array(),
    position_id: '',
    customer_id: '',
    car_id: '',
    license_plate: '',
    time_enter_start: '',
    time_enter_end: '',
    time_leave_start: '',
    time_leave_end: '',
    insurance_company_id: '',
    is_complete: '',
    complete_time_start: '',
    complete_time_end: '',
    is_caseclose: '',
    caseclose_time_start: '',
    caseclose_time_end: '',
    is_invalid: '',
    invalid_time_start: '',
    invalid_time_end: '',
    page: 0,
    num_per_page: 10
}) {
    return await allFetch('Report/WorkOrderPayLogReport', obj);
}

/**
 * @description 工單 Test
 */
export const WorkOrder = (() => {
    /**
     * @updatetime 2022.11.23
     * @description 工單建立
     */
    const WorkOrderMasterCreate = async function (obj = {
        wom_code: '',
        user_id: '',
        customer_id: '',
        customer_name: '',
        contacter_name: '',
        contacter_phone: '',
        contacter_email: '',
        contacter_city: '',
        contacter_area: '',
        contacter_address: '',
        car_id: '',
        mileage: '',
        time_enter: '',
        insurance_company_id: '',
        insurance_company_name: '',
        insurance_case_number: '',
        insurance_company_contacter_id: '',
        insurance_company_contacter_name: '',
        note: '',
        suggestion: '',
        position_id: '',
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterCreate', obj);
    }
    /**
     * @description  工單查詢
     * @param {string} wom_code 工單號碼
     * @param {string} status 狀態
     * @param {string} user_id 使用者流水號
     * @param {string} position_id 廠別流水號
     * @param {string} customer_id 車主流水號
     * @param {string} car_id 車流水號
     * @param {string} time_enter_start 進廠時間起
     * @param {string} time_enter_end 進廠時間迄
     * @param {string} time_leave_start 離廠時間起
     * @param {string} time_leave_end 離廠時間迄
     * @param {string} insurance_company_id 保險公司流水號
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns 
     */
    const WorkOrderMasterSearch = async function (obj = {
        wom_code: '',
        status: new Array(),
        position_id: '',
        customer_id: '',
        car_id: '',
        license_plate: '',
        time_enter_start: '',
        time_enter_end: '',
        time_leave_start: '',
        time_leave_end: '',
        insurance_company_id: '',
        is_complete: '',
        complete_time_start: '',
        complete_time_end: '',
        is_caseclose: '',
        caseclose_time_start: '',
        caseclose_time_end: '',
        is_invalid: '',
        invalid_time_start: '',
        invalid_time_end: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterSearch', obj);
    }

    /**
     * @description  工單細項
     * @param {string} wom_id 工單流水號
     * @returns 
     */
    const WorkOrderMasterDetail = async function (obj = {
        wom_id: '',
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterDetail', obj);
    }

    /**
     * @description  工單完工取消
     * @param {string} wom_id 工單流水號
     * @returns 
     */
    const WorkOrderMasterCompleteCancel = async function (obj = {
        wom_id: '',
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterCompleteCancel', obj);
    }

    /**
     * @description  工單結案取消
     * @param {string} wom_id 工單流水號
     * @returns 
     */
    const WorkOrderMasterCaseCloseCancel = async function (obj = {
        wom_id: '',
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterCaseCloseCancel', obj);
    }

    /**
     * @description 工單修改
     */
    const WorkOrderMasterUpdate = async function (obj = {
        wom_id: '',
        wom_code: '',
        user_id: '',
        position_id: '',
        customer_id: '',
        customer_name: '',
        contacter_name: '',
        contacter_phone: '',
        contacter_email: '',
        contacter_address: '',
        car_id: '',
        discount: '',
        mileage: '',
        time_enter: '',
        insurance_company_id: '',
        insurance_company_name: '',
        insurance_case_number: '',
        note: ''
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterUpdate', obj);
    }

    /**
     * @description 工單交修項目新建
     */
    const WorkOrderTurnoverRepairDetailCreate = async function (obj = {
        wom_id: '',
        trs_id: '',
        trs_code: '',
        trs_name: ''
    }) {
        return await allFetch('WorkOrder/WorkOrderTurnoverRepairDetailCreate', obj);
    }

    /**
     * @description  工單交修項目查詢
     * @param {string} wom_id 工單流水號
     * @returns 
     */
    const WorkOrderTurnoverRepairDetailSearch = async function (obj = {
        wom_id: '',
    }) {
        return await allFetch('WorkOrder/WorkOrderTurnoverRepairDetailSearch', obj);
    }

    /**
     * @description 工單交修項目修改
     */
    const WorkOrderTurnoverRepairDetailUpdate = async function (obj = {
        wotrd_id: '',
        trs_id: '',
        trs_code: '',
        trs_name: ''
    }) {
        return await allFetch('WorkOrder/WorkOrderTurnoverRepairDetailUpdate', obj);
    }

    /**
     * @description 工單交修項目刪除
     */
    const WorkOrderTurnoverRepairDetailDelete = async function (obj = {
        wotrd_id: ""
    }) {
        return await allFetch('WorkOrder/WorkOrderTurnoverRepairDetailDelete', obj);
    }

    /**
     * @description 工單作廢
     */
    const WorkOrderMasterInvalid = async function (obj = {
        wom_id: ''
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterInvalid', obj);
    }

    /**
     * @description 工單付款記錄查詢
     */
    const WorkOrderPayLogSearch = async function (obj = {
        wom_id: '',
        is_insurance: '',
        pay_method: '',
        pay_date_start: '',
        pay_date_end: '',
        invoice_number: ''
    }) {
        return await allFetch('WorkOrder/WorkOrderPayLogSearch', obj);
    }

    /**
     * @description 工單付款記錄新增
     */
    const WorkOrderPayLogCreate = async function (obj = {
        wom_id: ''
    }) {
        return await allFetch('WorkOrder/WorkOrderPayLogCreate', obj);
    }

    /**
     * @description 工單付款記錄新增
     */
    const WorkOrderPayLogUpdate = async function (obj = {
        pl_id: '',
        is_insurance: '',
        price: '',
        pay_method: '',
        pay_date: '',
        invoice_number: '',
        note: ''
    }) {
        return await allFetch('WorkOrder/WorkOrderPayLogUpdate', obj);
    }

    /**
     * @description 工單付款記錄刪除
     */
    const WorkOrderPayLogDelete = async function (obj = {
        pl_id: '',
    }) {
        return await allFetch('WorkOrder/WorkOrderPayLogDelete', obj);
    }

    /**
     * @description 工單完工
     */
    const WorkOrderMasterComplete = async function (obj = {
        wom_id: '',
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterComplete', obj);
    }

    /**
     * @description 工單結案
     */
    const WorkOrderMasterCaseClose = async function (obj = {
        wom_id: '',
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterCaseClose', obj);
    }

    /**
     * @description  工單庫存領用新建
     * @param {string} wom_id 工單流水號
     * @param {string} qcd_id 估價單商品細項流水號
     * @param {string} stock_id 庫存流水號
     * @param {string} count 數量
     * @param {string} total_price 總金額
     * @param {string} need_calc_stock 是否計算庫存
     * @returns 
     */
    const WorkOrderStockRequisitionCreate = async function (obj = {
        wom_id: '',
        qcd_id: '',
        stock_id: '',
        count: '',
        total_price: '',
        need_calc_stock: ''
    }) {
        return await allFetch('WorkOrder/WorkOrderStockRequisitionCreate', obj);
    }

    /**
     * @description  工單庫存領用查詢
     * @param {string} wom_id 工單流水號
     * @returns 
     */
    const WorkOrderStockRequisitionSearch = async function (obj = {
        wom_id: ""
    }) {
        return await allFetch('WorkOrder/WorkOrderStockRequisitionSearch', obj);
    }

    /**
     * @description  工單庫存領用修改
     * @param {string} wosr_id 工單庫存領用流水號
     * @param {string} wotrd_id 工單交修項目流水號
     * @param {string} count 數量
     * @param {string} need_calc_stock 是否計算庫存
     * @returns 
     */
    const WorkOrderStockRequisitionUpdate = async function (obj = {
        wosr_id: '',
        wotrd_id: '',
        count: '',
        need_calc_stock: ''
    }) {
        return await allFetch('WorkOrder/WorkOrderStockRequisitionUpdate', obj);
    }

    /**
     * @description  工單庫存領用刪除
     * @param {string} wosr_id 工單庫存領用流水號
     * @returns 
     */
    const WorkOrderStockRequisitionDelete = async function (obj = {
        wosr_id: ""
    }) {
        return await allFetch('WorkOrder/WorkOrderStockRequisitionDelete', obj);
    }

    /**
     * @description 維修清單細項新建
     * @param {*} wom_id 工單流水號
     * @param {*} master_type 來源類型
     * @param {*} master_id 來源主項流水號
     * @param {*} detail_id 來源細項流水號
     * @param {*} rld_type 維修清單細項類別
     * @param {*} rld_code 維修清單細項代號
     * @param {*} rld_name 維修清單細項名稱
     * @param {*} work_hours_setting 標準工時
     * @param {*} count 維修清單細項數量
     * @param {*} total_price 總金額
     * @param {*} insurance_price 保險金額
     * @param {*} discount 折扣
     * @param {*} note 備註
     * @returns 
     */
    const RepairListDetailCreate = async function (obj = {
        wom_id: '',
        master_type: '',
        master_id: '',
        detail_id: '',
        rld_type: '',
        rld_code: '',
        rld_name: '',
        work_hours_setting: '',
        count: '',
        total_price: '',
        insurance_price: '',
        discount: '',
        note: ''
    }) {
        return await allFetch('WorkOrder/RepairListDetailCreate', obj);
    }

    /**
     * @description 維修清單細項查詢
     * @param {*} wom_id 工單流水號
     * @returns 
     */
    const RepairListDetailSearch = async function (obj = {
        wom_id: '',
        master_type: '',
        master_id: '',
        dispatch_user_id: '',
        dispatch_statuses: ''
    }) {
        return await allFetch('WorkOrder/RepairListDetailSearch', obj);
    }

    /**
     * @description 維修清單細項查詢
     * @param {*} wom_id 工單流水號
     * @param {*} master_type 來源類型
     * @param {*} master_id 來源主項流水號
     * @param {*} dispatch_user_id 被派工使用者流水號
     * @param {*} dispatch_statuses 派工狀態們
     * @returns 
     */
    const RepairListDetailCheck = async function (obj = {
        wom_id: '',
    }) {
        return await allFetch('WorkOrder/RepairListDetailCheck', obj);
    }

    /**
     * @description 維修清單細項修改
     * @param {*} rld_id 維修清單細項流水號
     * @param {*} master_type 來源類型
     * @param {*} master_id 來源主項流水號
     * @param {*} detail_id 來源細項流水號
     * @param {*} rld_type 維修清單細項類別
     * @param {*} rld_code 維修清單細項代號
     * @param {*} rld_name 維修清單細項名稱
     * @param {*} work_hours_setting 標準工時
     * @param {*} count 維修清單細項數量
     * @param {*} total_price 總金額
     * @param {*} insurance_price 保險金額
     * @param {*} discount 折扣
     * @param {*} note 備註
     * @returns 
     */
    const RepairListDetailUpdate = async function (obj = {
        rld_id: '',
        master_type: '',
        master_id: '',
        detail_id: '',
        rld_type: '',
        rld_code: '',
        rld_name: '',
        work_hours_setting: '',
        count: '',
        total_price: '',
        insurance_price: '',
        discount: '',
        note: ''
    }) {
        return await allFetch('WorkOrder/RepairListDetailUpdate', obj);
    }

    /**
     * @description 維修清單細項刪除
     * @param {*} rld_id 維修清單細項流水號
     * @returns 
     */
    const RepairListDetailDelete = async function (obj = {
        wom_id: '',
        master_type: '',
        master_id: '',
        dispatch_user_id: ''
    }) {
        return await allFetch('WorkOrder/RepairListDetailDelete', obj);
    }

    /**
     * @description 維修清單們派工
     * @param {*} rldd_list 派工項目&使用者們
     * @returns 
     */
    const RepairListDetailDispatch = async function (obj = {
        rldd_list: []
    }) {
        return await allFetch('WorkOrder/RepairListDetailDispatch', obj);
    }

    /**
     * @description 維修清單們開工
     * @param {*} rld_ids 維修清單細項流水號們
     * @returns 
     */
    const RepairListDetailDispatchConstruct = async function (obj = {
        rldd_list: []
    }) {
        return await allFetch('WorkOrder/RepairListDetailDispatchConstruct', obj);
    }

    /**
     * @description 維修清單們停工
     * @param {*} rld_ids 維修清單細項流水號們
     * @returns 
     */
    const RepairListDetailDispatchRest = async function (obj = {
        rldd_list: []
    }) {
        return await allFetch('WorkOrder/RepairListDetailDispatchRest', obj);
    }

    /**
     * @description 維修清單們完成
     * @param {*} rld_ids 維修清單細項流水號們
     * @returns 
     */
    const RepairListDetailDispatchFinish = async function (obj = {
        rldd_list: []
    }) {
        return await allFetch('WorkOrder/RepairListDetailDispatchFinish', obj);
    }


    return {
        RepairListDetailReport,
        WorkOrderPayLogReport,
        WorkOrderMasterCreate,
        WorkOrderMasterSearch,
        WorkOrderMasterDetail,
        WorkOrderMasterUpdate,
        WorkOrderMasterInvalid,
        WorkOrderPayLogSearch,
        WorkOrderPayLogCreate,
        WorkOrderPayLogUpdate,
        WorkOrderPayLogDelete,
        WorkOrderMasterComplete,
        WorkOrderMasterCaseClose,
        WorkOrderTurnoverRepairDetailCreate,
        WorkOrderTurnoverRepairDetailSearch,
        WorkOrderTurnoverRepairDetailUpdate,
        WorkOrderTurnoverRepairDetailDelete,
        WorkOrderStockRequisitionCreate,
        WorkOrderStockRequisitionSearch,
        WorkOrderStockRequisitionUpdate,
        WorkOrderStockRequisitionDelete,
        RepairListDetailCreate,
        RepairListDetailSearch,
        RepairListDetailCheck,
        RepairListDetailUpdate,
        RepairListDetailDelete,
        RepairListDetailDispatch,
        RepairListDetailDispatchConstruct,
        RepairListDetailDispatchRest,
        RepairListDetailDispatchFinish,
        WorkOrderMasterCompleteCancel,
        WorkOrderMasterCaseCloseCancel
    }
})();